import PropTypes from "prop-types";
import { IMAGES } from "../../common/constants";

const NoInternetAlert = ({ title, heading, subText, imageSrc }: any) => {
  return (
    <div className="noDataWrapper">
      <figure className="nodataImage">
        <img src={imageSrc} alt="Connection-lost" />
      </figure>
      <div className="content">
        <h3 className="heading">{title}</h3>
        <h4 className="title">{heading}</h4>
        <p className="subTitle">{subText}</p>
      </div>
    </div>
  );
};

NoInternetAlert.propTypes = {
  title: PropTypes.string,
  heading: PropTypes.string,
  subText: PropTypes.string,
  imageSrc: PropTypes.string,
};

NoInternetAlert.defaultProps = {
  title: "Sorry!",
  heading: "We're experiencing technical difficulties.",
  subText: "Please try again later!",
  imageSrc: IMAGES.ConnectionLost,
};

export default NoInternetAlert;
